import { render, staticRenderFns } from "./TagVisualizacao.vue?vue&type=template&id=145c17c1&"
import script from "./TagVisualizacao.vue?vue&type=script&lang=js&"
export * from "./TagVisualizacao.vue?vue&type=script&lang=js&"
import style0 from "./TagVisualizacao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports